import React, { Component } from 'react';
import './Deals.css';
import { DealItem } from './DealItem';
import SimpleSlider from '../SimpleSlider/SimpleSlider';
import { Img } from '../UI/UI';
import { getImgUrl, limitText } from '../../Utility/Utility';

class Deals extends Component {
  constructor(props) {
    super(props);
    this.image_url = getImgUrl();

    this.dealsSliderSettings = {
      dots: true,
      infinite: true,
      cssEase: 'linear',
      autoplay: true,
      lazyLoad: 'ondemand',
      slidesToShow: this.props.items != undefined ? this.props.items : 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    this.deals = [
        {
            price: "699 €",
            title: "Israel Rail",
            desc: "8-Tage-Tour Israel Highlights mit der Bahn",
            link: "https://israelrail.com/de/tours/israel-highlights-mit-der-bahn-8-tage/",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/IsraelRail.jpg',
        },
        {
          price: "702 €",
          title: "Fit Reisen",
          desc: "David Dead Sea **** ˢ Wellness & Entspannung, 7 Nächte, DZ inkl. ÜF & Eintritt Spa, Klimakur zubuchbar",
          link: "https://www.fitreisen.de/david-dead-sea-ein-bokek-totes-meer-h352/?utm_source=teaser_extern&utm_medium=fva&utm_campaign=israel3#p=352P1NN",
          book_now: 'BUCHEN SIE JETZT',
          logo: 'Deals/FitReisen.jpg',
        },
        {
            price: "756 €",
            title: "Fit Reisen",
            desc: "Lot Spa Hotel **** Wellness & Entspannung, 7 Nächte, DZ inkl. HP & Eintritt Spa, Klimakur zubuchbar",
            link: "https://www.fitreisen.de/lot-spa-hotel-ein-bokek-totes-meer-h343/?utm_source=teaser_extern&utm_medium=fva&utm_campaign=israel2#dmin=7&p=343P1NN",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/FitReisen.jpg',
        },
        {
            price: "956 €",
            title: "Israel Tours & Travel",
            desc: "ISRAEL HIGHLIGHTS, 8 TÄGIGE RUNDREISE, INKL. 7 Ü/HP, TRANSFERS, DEUTSCHSPRACHIGER REISELEITER, ALLE EINTRITTSGELDER",
            link: "https://www.israel-tours-travel.de/israelrundreisen",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/IsraelTours&Travel.jpg',
        },
        {
            price: "1105 €",
            title: "Diesenhaus",
            desc: "8 Tage Klassische Israel-Rundreise. Ideal, um das Land kennenzulernen: Jerusalem, Galiläa, Totes Meer",
            link: "https://www.diesenhaus.de/reiseprogramm/reise/israel-rundreise/",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/Diesenhaus.jpg',
        },
        {
            price: "1281 €",
            title: "Ventus Reisen",
            desc: "Individuelle 10-tägige Privatreise als Selbstfahrer-Reise im Mietwagen",
            link: "https://www.ventus-reisen.de/399-israel-an-den-urspruengen-von-weltreligionen/",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/VentusReisen.jpg',
        },
        {
            price: "1299 €",
            title: "Berge & Meer",
            desc: "8-tägige Rundreise durch das Heilige Land mit Bad im Toten Meer, See Genezareth & Galiläa, Nazareth, Bethlehem & Jerusalem",
            link: "https://www.berge-meer.de/angebote/israel-rundreise-von-netanya-bis-tel-aviv-inkl-bad-im-toten-meer ",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/Berge&Meer.jpg',
        },
        {
            price: "1490 €",
            title: "Botros Tours",
            desc: "Rundreise „Geschichte, Kultur und Begegnung“ 8-tägige Rundreise inkl. Flüge Wien – Tel Aviv – Wien, Halbpension",
            link: "https://www.botrostours.at/product.php?id=5036",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/BotrosTours.jpg',
        },
        {
            price: "1750 €",
            title: "Biblische Reisen",
            desc: "Im Land der Bibel 8-tägige Studienreise, Linienflug, Halbpension, Rundfahrten und Ausflüge, alle Eintrittsgelder",
            link: "https://biblische-reisen.de/katalogreisen/nahost/israel/hlk06_im_land_der_bibel",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/BiblischeReisen.jpg',
        },
        {
            price: "1860 €",
            title: "Chavaja",
            desc: "Wanderreise auf den Spuren Jesu",
            link: "https://chavaja.de/2014-11-28-08-53-39/wanderreise-auf-den-spuren-jesu.html",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/Chavaja.jpg',
        },
        {
            price: "1995 €",
            title: "Studiosus",
            desc: "Heiliges Land - eine kompakte Studienreise ins Heilige Land , 8 Tage",
            link: "https://www.studiosus.com/Israel/Studienreise/Rundreise/3601--Israel-Heiliges-Land--Fluganreise",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/Studiosus.jpg',
        },
        {
            price: "1999 €",
            title: "Laufreisen",
            desc: "Israel: Eilat Wüsten Marathon, Halbmarathon und 10 km",
            link: "https://www.laufreisen.de/reisen/eilat",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/Laufreisen.jpg',
        },
        {
            price: "2095 €",
            title: "Hauser Exkursionen",
            desc: "9-tägige Wanderreise von der Wüste Negev zum Toten Meer und nach Galiläa mit kulturellen Höhepunkten in Masada und Jerusalem",
            link: "https://www.hauser-exkursionen.de/reise/israel-krater-wueste-totes-meer?variant=2022",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/HauserExkursionen.jpg',
        },
        {
            price: "2115 €",
            title: "ABS Travel",
            desc: "Insight Israel | 18-30, 9 tägige Rundreise für junge Erwachsene im Alter von 18 - 30 Jahre",
            link: "https://www.abstravel.ch/jugendreise",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/ABSTravel.jpg',
        },
        {
            price: "2748 €",
            title: "Eberhardt",
            desc: "Wanderreise Israel, 13 Tage, ca. 60 Wanderkilometer",
            link: "https://www.eberhardt-travel.de/reise/wanderreisen/israel-totes-meer/see-genezareth-totes-meer/il-aktiv",
            book_now: 'BUCHEN SIE JETZT',
            logo: 'Deals/Eberhardt.jpg',
        }
    ]

  }

  render() {
    const dealsHtml = this.deals.map((o) => {
      return (
        <DealItem
          key={o.title}
          brand={o.title}
          price={o.price}
          brandImg={o.logo}
          desc={o.desc}
          bookNowLink={o.link}
          descFontSize={o.fontSize}
        />
      );
    });
    return (
      <div className="deals-wrapper">
        <SimpleSlider settings={this.dealsSliderSettings}>{dealsHtml}</SimpleSlider>
      </div>
    );
  }
}

export default Deals;



// WEBPACK FOOTER //
// ./src/Components/Deals/Deals.js